import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'semantic-ui-react';
import PhoneInput from 'components/common/PhoneInput';
import InputNumberFormat from 'components/common/InputNumberFormat';
import { toDropDownOptions } from 'utils/dropdownOptions';
import saveWalletTypes from 'constants/options/saveWalletTypes';
import topupOptions from 'constants/options/topupOptions';
import formatNumber from 'helpers/formatNumber';

const TopupSaveRwandaForm = ({ onChange, form, walletItems }) => {
  const handleChange = (e, { name, value }) => {
    onChange(name, value);
  };

  const saveWallet = walletItems?.find(w =>
    w?.provider_name?.toLowerCase()?.includes('save'),
  );

  const selectedBalance = form.wallet
    ? saveWallet?.[form.wallet]
    : null;

  return (
    <div>
      <Form.Field
        required
        name="source"
        control={Select}
        fluid
        options={toDropDownOptions(topupOptions, true)}
        label="Channel"
        placeholder="Select"
        defaultValue="Phone_Number"
        onChange={handleChange}
      />

      {form.source === 'phone_number' && (
        <PhoneInput
          required
          name="phone_number"
          label="Phone number"
          onChange={handleChange}
        />
      )}

      {form.source === 'save_pay' && (
        <>
          <Form.Field
            required
            name="wallet"
            control={Select}
            fluid
            options={toDropDownOptions(saveWalletTypes, true)}
            label="Wallet"
            placeholder="Select"
            onChange={handleChange}
          />
          {form.wallet && (
            <div className="credit-org-form__balance">
              <span className="credit-org-form__balance--label">
                Available balance
              </span>
              <span className="credit-org-form__balance--value">
                {formatNumber(selectedBalance ?? 0)} Rwf
              </span>
            </div>
          )}
        </>
      )}

      <InputNumberFormat
        required
        name="amount"
        control={Input}
        label="Amount"
        type="number"
        placeholder="Amount..."
        onChange={handleChange}
      />

      <Form.TextArea
        required
        label="Description"
        autoComplete="off"
        placeholder="Description"
        name="description"
        className="textarea"
        onChange={handleChange}
      />
    </div>
  );
};

TopupSaveRwandaForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  walletItems: PropTypes.instanceOf(Array),
};

TopupSaveRwandaForm.defaultProps = {
  walletItems: [],
};

export default TopupSaveRwandaForm;
